export default __webpack_public_path__ + "static/cartaz_impulsa2026-219916bead0e3054e895c7d76c37023d.webp";